import React, { useContext } from 'react';
import styled from 'styled-components';
import { useBookingContext } from '../../Context';
import { BookerStateContext } from '../../hooks/useRuntimeCalBookingState';
import { CalSubsetOfHostUser } from '../../types';
import BackButton from '../BackButton';
import { Card, EventsList, OuterContainer } from './common/styles';

export default function StaffMemberSelectionStep() {
    const bookerContext = useBookingContext();
    const [state, bookingActions] = useContext(BookerStateContext);
    const { title, isTitleVisible } = bookerContext.serviceProviderStage;

    const handleBack = () => {
        bookingActions.setEventSelection(null);
        bookingActions.setEventSlug(null);
    };
    const selectedEventHosts = state?.eventSelection?.hosts || [];

    if (selectedEventHosts.length === 0 || !state?.eventSelection) {
        return null;
    }
    return (
        <Container data-auto='staff-member-selection-step'>
            <Header>
                {isTitleVisible && title && <Title>{title}</Title>}
                <EventTitle>{`${state.eventSelection.title} | ${state.eventSelection.displayPrice}`}</EventTitle>
            </Header>
            <StaffMembersList>
                {selectedEventHosts.map((host: CalSubsetOfHostUser) => (
                    <Card
                        key={'event-host-' + host.username}
                        data-auto='staff-member-selection-step-item'
                        onClick={() => bookingActions.setSelectedHost(host)}
                    >
                        <EventTitle>{host.name}</EventTitle>
                    </Card>
                ))}
            </StaffMembersList>
            <BackButton onClick={handleBack} />
        </Container>
    );
}

const Container = styled(OuterContainer)`
    padding: 24px;
`;

const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const StaffMembersList = styled(EventsList)`
    margin-block-start: 16px;
    margin-block-end: 16px;
    max-height: 345px;
    overflow-y: auto;
`;

const Title = styled.span`
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    margin-block-end: 4px;
`;

const EventTitle = styled.span`
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
`;
